import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../../src/app/core/models/generic-models';
import {
  verifyEmailRequest,
  verifyEmailRequestSuccess,
  verifyEmailRequestFailure
} from '../actions/verify-email.actions';
import { IVerifyEmailRequest, IVerifyEmailResponse } from '../models/verify-email.model';

export const verifyEmailFeatureKey = 'verifyEmail';

export interface VerifyEmailState {
  isLoading: boolean;
  verifyEmailRequest: IVerifyEmailRequest;
  verifyEmailResponse: IVerifyEmailResponse;
  verifyEmailFailure: IGenericError<ErrorResponse>;
}

export const initialState: VerifyEmailState = {
  verifyEmailRequest: undefined,
  verifyEmailResponse: undefined,
  verifyEmailFailure: undefined,
  isLoading: false
};

export const reducer = createReducer(
  initialState,

  on(verifyEmailRequest, (state, action) => ({
    ...state,
    verifyEmailRequest: action.request,
    isLoading: true
  })),

  on(verifyEmailRequestSuccess, (state, action) => ({
    ...state,
    verifyEmailResponse: action.response,
    isLoading: false
  })),

  on(verifyEmailRequestFailure, (state, action) => ({
    ...state,
    verifyEmailFailure: action.error,
    isLoading: false
  }))
);

export const getVerifyEmailRequest = (state: VerifyEmailState) => state.verifyEmailRequest;
export const getVerifyEmailResponse = (state: VerifyEmailState) => state.verifyEmailResponse;
export const getVerifyEmailFailure = (state: VerifyEmailState) => state.verifyEmailFailure;
export const getVerifyEmailIsLoading = (state: VerifyEmailState) => state.isLoading;
